import { Api } from './Api';

class PublicPassword {
    get(customerId, customerCode, path) {
        return fetch(Api.getBaseUrl() + 'publicpassword/' + customerId + '/?customerCode=' + customerCode + '&field=' + path, Api.getOptions());
    }

    put(customerId, customerCode, password, path) {
        const body = {
            password: password
        };
        return fetch(Api.getBaseUrl() + 'publicpassword/' + customerId + '/?customerCode=' + customerCode + '&field=' + path, Api.getOptions('PUT', body));
    }
}

export default PublicPassword;